import {createBrowserRouter, Navigate} from "react-router";
import Home from "../components/Home";
import Layout from "../Layout";
import {PATH} from "./routes";
import Services from "../components/Services";
import Contact from "../components/Contact";

const router = createBrowserRouter([
    {
        element: <Layout/>,
        children: [
            {path: PATH.HOME, element: <Home/>},
            {path: PATH.SERVICES, element: <Services/>},
            {path: PATH.CONTACT, element: <Contact/>},
            {path: "*", element: <Navigate to={PATH.HOME} replace/>}
        ]
    }
])

export default router;